<template>
    <div class="order-detail">
        <div>
            <veui-breadcrumb
                ui="strong"
                :routes="routes"
                @redirect="handleRedirect"
            >
            </veui-breadcrumb>
        </div>
        <div
            class="order-detail-section"
            :class="{
                'order-detail-section-transtion': selectedList.length > 1,
            }"
        >
            <div class="order-detail-title">线索详情</div>
            <div class="order-detail-filter">
                <veui-label>
                    线索领域
                    <veui-select
                        v-model="clue_territory"
                        class="order-detail-select"
                        data-stat-ignore
                        clearable
                        multiple
                        @change="changeSelect"
                    >
                        <veui-option
                            v-for="(item, index) in doaminOption"
                            :key="index"
                            :value="item.value"
                            :label="item.text"
                        />
                    </veui-select>
                </veui-label>
                <veui-label style="margin-left: 48px">
                    线索地域
                    <veui-select
                        v-model="clue_city"
                        class="order-detail-select"
                        data-stat-ignore
                        clearable
                        multiple
                        @change="changeSelect"
                    >
                        <veui-option
                            v-for="(item, index) in regionOption"
                            :key="index"
                            :value="item.value"
                            :label="item.text"
                        />
                    </veui-select>
                </veui-label>
            </div>
            <div class="order-detail-table">
                <div v-if="selectedList.length > 1" class="order-detail-batch">
                    <div class="order-detail-batch-text">
                        已选{{ selectedList.length }}行
                    </div>
                    <div class="order-detail-batch-center">
                        <veui-button
                            @click="handleBatch('edit')"
                        >批量绑定</veui-button>
                    </div>
                    <div
                        class="order-detail-batch-close"
                        @click="handleBatch('reset')"
                    >
                        <veui-icon name="times"/>
                    </div>
                </div>
                <div
                    class="order-detail-table-content"
                    :class="{
                        'order-detail-table-transtion': selectedList.length > 1,
                    }"
                >
                    <veui-table
                        v-if="data.length"
                        ui="m"
                        :data="data"
                        key-field="clue_id"
                        selectable
                        select-mode="multiple"
                        :selected.sync="selectedList"
                    >
                        <veui-table-column
                            field="id"
                            title="序号"
                            width="53"
                            align="center"
                        >
                            <template slot-scope="{index}">
                                <span>{{ rn * (pn - 1) + (index + 1) }}</span>
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="clue_territory"
                            title="线索领域"
                            width="80"
                        />
                        <veui-table-column
                            field="clue_city"
                            title="线索地域"
                            width="80"
                        />
                        <veui-table-column
                            field="clue_phone_num"
                            title="联系方式"
                            width="113"
                        />
                        <veui-table-column
                            field="clue_collect_time"
                            title="线索获取时间"
                            width="175"
                        />
                        <veui-table-column
                            field="clue_status"
                            title="绑定状态"
                            width="125"
                        >
                            <template slot-scope="{binds = {}}">
                                <div>
                                    {{
                                        binds.bind_status ? "已绑定" : "未绑定"
                                    }}
                                </div>
                                <div v-if="binds.bind_status">
                                    {{ binds.tel_a }}
                                </div>
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="leavings_bind_num"
                            title="剩余绑定次数"
                            width="99"
                        />
                        <veui-table-column
                            field="operation"
                            title="操作"
                            width="150"
                        >
                            <div
                                slot-scope="{
                                    binds = {},
                                    clue_id,
                                    leavings_bind_num,
                                }"
                                class="order-detail-operation"
                            >
                                <a
                                    v-if="+binds.total_binds === 0"
                                    class="operation-first-bind"
                                    @click="
                                        openBindPhoneDialog(
                                            'phoneBind',
                                            clue_id
                                        )
                                    "
                                >绑定</a>
                                <a
                                    v-if="
                                        binds.total_binds > 0 &&
                                            binds.bind_status
                                    "
                                    class="operation-change-bind"
                                    :class="{
                                        'bind-disabled':
                                            leavings_bind_num === 0,
                                    }"
                                    @click="
                                        openBindPhoneDialog(
                                            'changeBind',
                                            clue_id,
                                            leavings_bind_num === 0
                                        )
                                    "
                                >更换绑定</a>
                                <a
                                    v-if="
                                        binds.total_binds > 0 &&
                                            !binds.bind_status
                                    "
                                    class="operation-again-bind"
                                    :class="{
                                        'bind-disabled':
                                            leavings_bind_num === 0,
                                    }"
                                    @click="
                                        openBindPhoneDialog(
                                            'phoneBind',
                                            clue_id,
                                            leavings_bind_num === 0
                                        )
                                    "
                                >重新绑定</a>
                                <a
                                    v-if="+binds.total_binds > 0"
                                    class="operation-bind-list"
                                    @click="
                                        openBindPhoneDialog(
                                            'recordList',
                                            clue_id
                                        )
                                    "
                                >绑定记录</a>
                            </div>
                        </veui-table-column>
                    </veui-table>
                    <div v-else class="order-detail-empty">
                        <div>
                            <img src="../image/icon-empty.png"/>
                            <div class="order-detail-empty-text">
                                {{ loading ? "暂无订单" : "数据正在加载中" }}
                            </div>
                        </div>
                    </div>
                    <div v-if="data.length" class="order-detail-pagination">
                        <veui-pagination
                            :page="pn"
                            :total="total"
                            :page-size="rn"
                            :page-sizes="[10, 20, 30]"
                            @pagesizechange="pagesizechange"
                            @redirect="pageChange"
                        />
                    </div>
                </div>
            </div>
        </div>
        <bind-phone-dialog
            :show.sync="bindPhoneDialogShow"
            :dialog-type="dialogType"
            :clue-id="dialogClueId"
            @handleBindPhone="handleBindPhone"
        ></bind-phone-dialog>
    </div>
</template>

<script>
/**
 * @file orderDetail.vue
 * @desc 线索详情
 * @author sunxiaofeng01
 */
import {
    Select,
    Label,
    Table,
    Column,
    Pagination,
    Option,
    Breadcrumb,
    Button,
    Icon
} from 'veui';
import bendSDK from '@baidu/bend-plugin-sdk';
import 'veui-theme-dls-icons/times';
import bindPhoneDialog from './bindPhoneDialog.vue';
import {cloneDeep, get} from 'lodash';
const url = {
    clueOrderdetail: 'law:/themis/law/commodity/clue_orderdetail',
    clueQuerySelect: 'law:/themis/law/commodity/clue_queryselect'
};
export default {
    name: 'orderDetail',
    data() {
        return {
            order_id: this.$route.query.orderId,
            pn: 1,
            rn: 10,
            total: 10,
            data: [],
            clue_city: [],
            clue_territory: [],
            doaminOption: [],
            regionOption: [],
            routes: [
                {
                    label: '订单管理',
                    type: 'link'
                },
                {
                    label: '线索详情'
                }
            ],
            loading: false,
            selectedList: [],
            bindPhoneDialogShow: false,
            dialogType: '',
            dialogClueId: ''
        };
    },
    components: {
        'veui-select': Select,
        'veui-label': Label,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-pagination': Pagination,
        'veui-option': Option,
        'veui-breadcrumb': Breadcrumb,
        'veui-button': Button,
        'veui-icon': Icon,
        'bind-phone-dialog': bindPhoneDialog
    },
    created() {
        this.getDetail();
        this.getClueQuerySelect();
    },
    methods: {
        getDetail() {
            const params = {
                order_id: this.order_id,
                clue_territory: this.clue_territory.join(),
                clue_city: this.clue_city.join(),
                pn: this.pn,
                rn: this.rn
            };
            this.$http
                .get(url.clueOrderdetail, {
                    params
                })
                .then(resp => {
                    const data = resp?.data?.data || {};
                    this.loading = true;
                    if (data && data.data) {
                        this.data = data.data.list || [];
                        this.total = data.data.total || 10;
                        this.data = this.data.map(item => {
                            if (item.binds) {
                                item.leavings_bind_num
                                    = item.binds.max_binds
                                        - item.binds.total_binds;
                                item.leavings_bind_num
                                    = item.leavings_bind_num < 0
                                        ? 0
                                        : item.leavings_bind_num;
                                item.disabled = item.leavings_bind_num <= 0;
                            }
                            return item;
                        });
                    }
                    else {
                        this.data = [];
                        this.total = 10;
                    }
                })
                .catch(err => this.$normalizeResponseError(err));
        },
        getClueQuerySelect() {
            const params = {
                select_name: 'clue_territory,clue_city',
                query_refer: 'lvlin_b'
            };
            this.$http
                .get(url.clueQuerySelect, {
                    params
                })
                .then(resp => {
                    const data = this.$normalizeResponseData(resp);
                    if (data && data.data) {
                        this.doaminOption = get(
                            data,
                            'data.clue_territory',
                            []
                        );
                        this.regionOption = get(data, 'data.clue_city', []);
                    }
                })
                .catch(err => this.$normalizeResponseError(err));
        },
        pagesizechange(pageSize) {
            this.rn = pageSize;
            this.pn = 1;
            this.getDetail();
        },
        pageChange(page) {
            this.pn = page;
            this.getDetail();
        },
        changeSelect() {
            this.pn = 1;
            this.getDetail();
        },
        handleRedirect(event, route) {
            if (route.label === '订单管理') {
                this.$router.push({
                    name: 'clueOrderManage'
                });
            }
        },
        // 打开绑定弹窗
        openBindPhoneDialog(type, clueId, disabled = false) {
            if (disabled) {
                return;
            }
            if (
                (type === 'phoneBind' || type === 'changeBind')
                && !Array.isArray(clueId)
            ) {
                clueId = [clueId];
            }
            this.dialogType = type;
            this.dialogClueId = clueId;
            this.bindPhoneDialogShow = true;
        },
        // 批量绑定
        handleBatch(type) {
            if (type === 'edit') {
                const clueIdList = cloneDeep(this.selectedList);
                this.openBindPhoneDialog('phoneBind', clueIdList);
            }
            else {
                this.selectedList = [];
            }
        },
        // 绑定弹窗关闭
        handleBindPhone(bindStatus) {
            this.bindPhoneDialogShow = false;
            this.dialogClueId = '';
            if (bindStatus) {
                this.selectedList = [];
                this.getDetail();
            }
        }
    }
};
</script>

<style scoped lang="stylus">
.order-detail {
    display: flex;
    flex-direction: column;
    .order-detail-section {
        flex: 1;
        transition: all;
        padding: 24px;
        margin: 24px 0 0;
        background: #fff;
        border-radius: 4px;
        transition: all 0.3s linear;
    }
    .order-detail-section-transtion {
        padding-bottom: 68px;
    }
    &-title {
        height: 28px;
        line-height: 28px;
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #000;
        font-weight: 600;
    }
    &-filter {
        margin-top: 20px;
    }
    &-select {
        width: 280px;
        margin-left: 8px;
        vertical-align: middle;
    }
    &-table {
        margin-top: 20px;
        position: relative;
        height: calc(100% - 80px);
        .order-detail-table-content {
            height: 100%;
        }
        .order-detail-batch {
            position: absolute;
            top: 0;
            width: 100%;
            padding: 0 17px;
            height: 44px;
            background: #0052CC;
            display: flex;
            align-items: center;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            &-text {
                width: 72px;
                text-align: center;
                color: #fff;
            }
            &-center {
                flex: 1;
            }
            &-close {
                width: 12px;
                height: 44px;
                line-height: 44px;
                color: #fff;
                font-size: 12px;
                cursor: pointer;
            }
        }
        .order-detail-table-content {
            transform: translateY(0px);
            transition: all 0.3s linear;
        }
        .order-detail-table-transtion {
            transform: translateY(44px);
        }
    }
    &-pagination {
        margin-top: 16px;
        display: flex;
        justify-content: flex-end;
    }
    /deep/ .veui-select, /deep/ .veui-input {
        vertical-align: middle;
    }
    .order-detail-empty {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        &-text {
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            color: #A8B0BF;
            text-align: center;
            font-weight: 400;
        }
    }
    .order-detail-operation {
        a {
            margin-left: 6px;
            color: #0052CC;
        }
        a:first-child {
            margin-left: 0;
        }
        a::hover {
            color: #0066FF;
        }
        a::active {
            color: #0045AD;
        }
        .bind-disabled {
            color: #8FBCFF;
        }
    }
}
</style>
